import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { mergeMap, of } from 'rxjs';
import * as UserActions from './user.actions';
import { UserService } from '@ieCore/services/user.service';

@Injectable()
export class UserEffects {
  loadUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.load),
      mergeMap(() =>
        this.userService.getMe().response.pipe(
          map((user) => UserActions.loadSuccess({ user })),
          catchError((error) => of(UserActions.loadFailure({ error }))),
          // A clear kills any load still in flight (delta re-gate finding
          // 2): the late response of a dead session must not repopulate the
          // store. On the INNER pipe on purpose — armed per-load, so a load
          // dispatched AFTER a clear still completes (spec-pinned).
          // `mergeMap` is retained: switchMap would cancel only on a
          // SUBSEQUENT load, which never comes for a clear-with-no-relogin
          // (the idle timeout), i.e. exactly the harm this fix targets.
          takeUntil(this.actions$.pipe(ofType(UserActions.clear))),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private userService: UserService,
  ) {}
}
